import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import "../styles/TreatmentTreeDetails.scss";
import { useTreatmentsByRef } from "../Apis/useApiQueries";
import { metaPixelEvents } from "../utils/metaPixel";
import { scrollToTop } from "../utils/scrollToTop";
import mezoterapia from "../images/mezoterapia.jpg";
import defaultImage from "../images/default.jpeg";
import PRP2 from "../images/PRP2.jpg";
import minoxi from "../images/minoxi.jpg";
import Stemcells from "../images/Stemcells.jpg";

const images = {
  Stemcells,
  mezoterapia,
  minoxi,
  PRP2,
  default: defaultImage,
};

const TreatmentTreeDetails = () => {
  const { treatmentRef } = useParams();
  const {
    data: filteredTreatments = [],
    isLoading,
    error,
  } = useTreatmentsByRef(treatmentRef);

  // Track treatment category browsing
  useEffect(() => {
    if (treatmentRef) {
      metaPixelEvents.trackSearch(treatmentRef);
    }
  }, [treatmentRef]);

  if (isLoading) return <div className="loading">טוען טיפולים...</div>;
  if (error) return <p className="error">Error: {error.message}</p>;
  if (filteredTreatments.length === 0) return <p>No treatments found.</p>;

  return (
    <div className="treatment-tree-details-page">
      <h1>{treatmentRef}</h1>
      <div className="treatment-grid">
        {filteredTreatments.map((treatment) => (
          <div key={treatment._id} className="treatment-card">
            <Link
              to={`/treatment/${treatment.name}`}
              className="treatment-link"
              onClick={() => {
                metaPixelEvents.trackViewContent(treatment.name, treatmentRef);
                scrollToTop();
              }}
            >
              <img
                src={
                  treatment.imgName ? images[treatment.imgName] : images.default
                }
                className="treatment-photo"
                alt={treatment.name}
              />
              <div className="icon-overlay">
                <i
                  className="fa-regular fa-share-from-square fa-xl"
                  style={{ color: "rgb(0 77 80 / 74%)" }}
                ></i>
              </div>
              <h2 dir="auto">{treatment.name}</h2>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TreatmentTreeDetails;
